import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip'; // Import Tooltip from MUI
import "./Chat.css";
import message from "../../../../assets/images/message.svg";
import { MenuDots } from '../../../../Components';
import deleteIcon from "../../../../assets/images/delete.svg";
import shareIcon from "../../../../assets/images/share.svg";
import Modal from "react-modal";
import Zoom from '@mui/material/Zoom';

const Chat = ({ title, onClick, onDelete, onShare, isDarkMode, isActive }) => {

    const [showPopup, setShowPopup] = useState(false);

    // function to limit the length of the title
    const truncateTitle = (title, maxLength) => {
        return title.length > maxLength ? `${title.substring(0, maxLength)}...` : title;
    };

    const handleDelete = () => {
        setShowPopup(true);
    };

    const cancelDelete = () => {
        setShowPopup(false);
    };

    const menuChildren = [
        <div className={`chat-props ${isDarkMode ? 'dark-mode' : ''}`} onClick={onShare}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" className="h-5 w-5 shrink-0"><path fill="#ccc" fill-rule="evenodd" d="M11.293 3.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 6.414V15a1 1 0 1 1-2 0V6.414L8.707 8.707a1 1 0 0 1-1.414-1.414zM4 14a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3a1 1 0 1 1 2 0v3a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-3a1 1 0 0 1 1-1" clip-rule="evenodd"></path></svg>
            <h1 className='chat-prop-title'>Share</h1>
        </div>,
        <div className='chat-props' onClick={handleDelete}>
            <img className='chat-icon' src={deleteIcon} alt="delete icon"/>
            <h1 className='chat-prop-title chat-delete'>Delete</h1>
        </div>
    ];

    return (
        <div className={`chat-message ${isActive ? 'active-chat' : ''} ${isDarkMode ? 'dark-mode' : ''}`}>
            <div onClick={onClick} className='d-flex align-items-center' style={{ minWidth: '91%'}}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="chat_bubble" clipPath="url(#clip0_1515_1037)">
                        <path id="Vector" d="M16.6665 1.66669H3.33317C2.4165 1.66669 1.6665 2.41669 1.6665 3.33335V18.3334L4.99984 15H16.6665C17.5832 15 18.3332 14.25 18.3332 13.3334V3.33335C18.3332 2.41669 17.5832 1.66669 16.6665 1.66669ZM16.6665 13.3334H4.99984L3.33317 15V3.33335H16.6665V13.3334Z" fill="#474747"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_1515_1037">
                            <rect width="20" height="20" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                {/* Wrap truncateTitle with Tooltip */}
                <Tooltip title={title} arrow placement="right" TransitionComponent={Zoom}>
                    <h1 className='chat-message-title'>{truncateTitle(title, 19)}</h1>
                </Tooltip>
            </div>
           
            <div className='chat-dots'>
                <MenuDots
                    menuClass={"chatbot-menu"}
                    options={menuChildren}
                    bgColor={isDarkMode ? "#2f2f2f" : "#fff"}
                />
            </div>

            <Modal 
                isOpen={showPopup} 
                onRequestClose={cancelDelete}
                overlayClassName={`${isDarkMode ? 'custom-modal-overlay' : ''}`}
            >
                <div className={`confirm-delete-container ${isDarkMode ? 'dark-mode' : ''}`}>
                    <div className='confirm-delete-content'>
                        <img className='delete-img' src={deleteIcon} alt="delete"/>
                        <h1 className='delete-title'>Are you sure?</h1>
                    </div>
                    <div className='confirm-btns'>
                        <button className='cancle-delete' onClick={cancelDelete}>Cancel</button>
                        <button className='confirm-delete' onClick={onDelete}>Delete</button>
                    </div>
                </div>  
            </Modal>
        </div>
    )
}

export default Chat;
